export const getKeyedAlerts = alerts => {
  const occurrences = new Map();

  return alerts.map(alert => {
    const base = `${alert.alertType}-${alert.comment}`;
    const occurrence = (occurrences.get(base) ?? 0) + 1;

    occurrences.set(base, occurrence);

    return { ...alert, key: `${base}-${occurrence}` };
  });
};
